export default __webpack_public_path__ + "static/media/scholarship.02915059.png";